import { app } from '../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {

    $stateProvider.state('public.subscription-success', {
        url: '/subscription_success',
        component: 'subscriptionSuccess',
        resolve: {},
    });
}



// WEBPACK FOOTER //
// ./src/portal/states/public/subscription-success/subscription-success.state.js